import React, { useEffect, useState } from 'react';
import { Alert, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import { BlockHead, BlockTitle, Button, Col, Icon, Row } from '../../../components/Component';
import TextInput from '../../components/inputs/TextInput';
import PhoneInput from 'react-phone-input-2';
import "react-phone-input-2/lib/style.css";
import { isUrLPrefixValidString, messageToast } from '../../../utils/Utils';
import ListText from '../text/ListText';
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import { useDispatch } from 'react-redux';
import { fail_admin_create_tenant, loading_admin_create_tenant, success_admin_create_tenant } from '../../../reducers/auth_tenant/admin_create_tenant_Slice';
import { CREATE_TENANT_ERROR_MSG, CREATE_TENANT_SUCCESS_MSG } from '../../../utils/error_success_messages';
import { ADMIN_CREATE_TENANT_API } from '../../../api/api_data';
import { reset_retrieve_tenants_list } from '../../../reducers/auth_tenant/retrieve_tenants_list_Slice';
import { useSelector } from 'react-redux';
import * as app_consts from "../../../utils/app_consts";

const initalState = { contact_first_name: "", contact_last_name: "", contact_mobile_number: "", contact_email_address: "", tenant_name: "", tenant_mobile_number: "", tenant_email_address: "", add_tenant_url_prefix: "", tenant_tpin: "", tenant_registration_number: "" };

const AddTenantModal = ({
 openModal,
 setOpenModal,
 type,
 modalTitle,
 modalDescription,
 succFunc,
 size,
 accountId,
 openOtherModalFunc,
 tenant_info
}) => {
 const [modal, setModal] = useState(false);
 const [step, setStep] = useState(1);
 const [error, setError] = useState("");
 const [loading, setLoading] = useState(false);
 const [formData, setFormData] = useState(initalState);

 const dispatch = useDispatch();

 useEffect(() => {
  setError("");
  setFormData(initalState);
  setModal(openModal);
 }, [openModal]);

 const toggleModal = () => {
  setOpenModal(!modal);
 };
 // Handle Change Function
 const handleChange = (e) => {
  setFormData({ ...formData, [e.target.name]: e.target.value });
 };

 const handlePreview = () => {
  setError("");
  setStep(2);
 };

 const handlePhoneNumberChange = (label, phone) => {
  setFormData({ ...formData, [label]: phone });
 };

 const handleSubmit = () => {
  setError("");
  // 
  dispatch(tenant_auth_actions_helper(loading_admin_create_tenant, success_admin_create_tenant, fail_admin_create_tenant, CREATE_TENANT_ERROR_MSG, CREATE_TENANT_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${ADMIN_CREATE_TENANT_API}`, formData));
 };
 const retrieve_tenants_list_listener = useSelector((state) => state.admin_create_tenant.admin_create_tenant);

 useEffect(() => {
  if (retrieve_tenants_list_listener.status !== app_consts.IDLE)
  {
   if (retrieve_tenants_list_listener.status === app_consts.LOADING)
   {
    setLoading(true);
    setError("");
   } else
   {
    setLoading(false);
    if (retrieve_tenants_list_listener.status === app_consts.FAIL)
    {
     setError(retrieve_tenants_list_listener.message, app_consts.FAIL);
     messageToast(retrieve_tenants_list_listener.message, app_consts.FAIL);
    } else if (retrieve_tenants_list_listener.status === app_consts.SUCCESS)
    {
     succFunc();
     toggleModal();
    }
    dispatch(reset_retrieve_tenants_list());
   }
  }
 }, [retrieve_tenants_list_listener]);

 return (
  <>
   <Modal
    isOpen={modal}
    // toggle={!modalLoading ? toggleModal : ""}
    className="modal-dialog-centered"
    size={size ? size : "lg"}
   >
    <ModalHeader toggle={!loading ? toggleModal : ""}>{modalTitle}</ModalHeader>
    <ModalBody>
     <div className="d-flex justify-content-between mb-2">
      <h5 className="card-title text-center w-100">Add Tenant Form</h5>
     </div>{step === 2 && (
      <div
       className="nk-block-head-sub mb-2"
       style={{ cursor: "pointer" }}
       onClick={(e) => {
        e.preventDefault();
        setStep(1);
        setFormData({ ...formData, ["contact_mobile_number"]: "", ["tenant_mobile_number"]: "" });
       }}
      >
       <Icon name="arrow-left" />
       <span>back</span>
      </div>
     )}
     {error && (
      <div className="mb-3 w-100">
       <Alert color="danger" className="alert-icon">
        <Icon name="alert-circle" /> {error}{" "}
       </Alert>
      </div>
     )}
     {step === 1 ? (
      <>
       <form
        onSubmit={(e) => {
         e.preventDefault();
        }}
       >
        <Row className="g-4">
         <div className="mt-4 ">
          <BlockHead>
           <BlockTitle tag="h6">Contact Person Details</BlockTitle>
          </BlockHead>
         </div>
         <TextInput
          label="First Name"
          required
          type="text"
          id_val="contact_first_name"
          value={formData.contact_first_name}
          colSize="6"
          name="contact_first_name"
          handleChange={handleChange}
         />
         <TextInput
          label="Last Name"
          required
          type="text"
          id_val="contact_last_name"
          value={formData.contact_last_name}
          colSize="6"
          name="contact_last_name"
          handleChange={handleChange}
         />
         <TextInput
          label="Email Address"
          required
          type="email"
          id_val="contact_email_address"
          value={formData.contact_email_address}
          colSize="6"
          name="contact_email_address"
          handleChange={handleChange}
         />
         <Col lg="6">
          <div className="form-group">
           <div className="form-label-group">
            <label className="form-label" htmlFor="contact_mobile_number">
             Contact Mobile Number<span className='text-danger pr-2'>{`* `}</span>
            </label>
           </div>
           <div className="form-control-wrap">
            <PhoneInput
             country={"zm"}
             value={formData.phone_number}
             onChange={(phone) => handlePhoneNumberChange("contact_mobile_number", phone)}
             copyNumbersOnly={false}
             inputStyle={{ width: '100%' }}
            />
           </div>
          </div>
         </Col>
         <div className="mt-4 ">
          <BlockHead>
           <BlockTitle tag="h6">Tenant Details</BlockTitle>
          </BlockHead>
         </div>
         <TextInput
          label="Tenant Name"
          required
          type="text"
          id_val="tenant_name"
          value={formData.tenant_name}
          colSize="6"
          name="tenant_name"
          handleChange={handleChange}
         />
         <TextInput
          label="Tenant Email Address"
          required
          type="text"
          id_val="tenant_email_address"
          value={formData.tenant_email_address}
          colSize="6"
          name="tenant_email_address"
          handleChange={handleChange}
         />
         <Col lg="6">
          <div className="form-group">
           <div className="form-label-group">
            <label className="form-label" htmlFor="tenant_mobile_number">
             Tenant Mobile Number<span className='text-danger pr-2'>{`* `}</span>
            </label>
           </div>
           <div className="form-control-wrap">
            <PhoneInput
             country={"zm"}
             value={formData.phone_number}
             onChange={(phone) => handlePhoneNumberChange("tenant_mobile_number", phone)}
             copyNumbersOnly={false}
             inputStyle={{ width: '100%' }}
            />
           </div>
          </div>
         </Col>
         <TextInput
          label="Tenant URL Prefix"
          required
          type="text"
          id_val="tenant_url_prefix"
          value={formData.add_tenant_url_prefix}
          colSize="6"
          name="add_tenant_url_prefix"
          handleChange={handleChange}
          error_stat={formData?.add_tenant_url_prefix && !isUrLPrefixValidString(formData?.add_tenant_url_prefix)}
          err_Msg="Should be 5 or more letters and have letters only and an underscore to separate words."
         />
         <TextInput
          label="Tenant Tax No (Optional):"
          type="text"
          id_val="tenant_tpin"
          value={formData.tenant_tpin}
          colSize="6"
          name="tenant_tpin"
          handleChange={handleChange}
         />
         <TextInput
          label="Tenant Registration Number (Optional):"
          type="text"
          id_val="tenant_registration_number"
          value={formData.tenant_registration_number}
          colSize="6"
          name="tenant_registration_number"
          handleChange={handleChange}
         />
         <Col xl="12" className="d-flex justify-content-end">
          <Button
           onClick={handlePreview}
           size="lg"
           type="submit"
           color="primary"
           disabled={
            loading ? loading : !(formData?.contact_email_address && formData?.contact_first_name && formData?.contact_last_name && formData?.contact_mobile_number && formData?.tenant_email_address && formData?.tenant_mobile_number && formData?.tenant_name && formData?.add_tenant_url_prefix)
           }
          >
           Preview and Add Tenant
          </Button>
         </Col>
        </Row>
       </form>
      </>
     )
      :
      <>
       <div className="mt-4 ">
        <BlockHead>
         <BlockTitle tag="h6">Contact Details</BlockTitle>
        </BlockHead>
       </div>
       <ListText dataItem="data-item mySmall" label="First Name" value={formData.contact_first_name} />
       <ListText dataItem="data-item mySmall" label="Last Name" value={formData.contact_last_name} />
       <ListText dataItem="data-item mySmall" label="Email Address" value={formData.contact_email_address} />
       <ListText dataItem="data-item mySmall" label="Mobile Number" value={formData.contact_mobile_number} />
       <div className="mt-4 ">
        <BlockHead>
         <BlockTitle tag="h6">Tenant Details</BlockTitle>
        </BlockHead>
       </div>
       <ListText dataItem="data-item mySmall" label="Tenant Name" value={formData.tenant_name} />
       <ListText dataItem="data-item mySmall" label="Tenent Email Address" value={formData.tenant_email_address} />
       <ListText dataItem="data-item mySmall" label="Tenant Mobile Number" value={formData.tenant_mobile_number} />
       <ListText dataItem="data-item mySmall" label="Tenant URL Prefix" value={formData.add_tenant_url_prefix} />
       <ListText dataItem="data-item mySmall" label="Tenant Tax Number (optional)" value={formData.tenant_tpin || "--"} />
       <ListText dataItem="data-item mySmall" label="Tenant Registration Number" value={formData.tenant_registration_number || "--"} />
       <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
        <Button onClick={handleSubmit} disabled={loading} color="primary">
         {loading ? <Spinner size="sm" color="light" /> : "Add Tenant"}
        </Button>
       </Col>
      </>
     }
    </ModalBody>
   </Modal>

  </>
 );
};

export default AddTenantModal;